export default __webpack_public_path__ + "capitec_landingPageImg.png";